import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import LabService from "services/labService";
import { removeRecordForLab } from "utils/labUtils";

export const initialState = {
  list: [],
  drawHistoryForLab: [],
  drawHistoryForLabLoading: false,
  loading: false,
  creating: false,
  updating: false,
  errorMessages: [],
  showMessage: false,
};

export const fetchLabTableData = createAsyncThunk(
  "/fetchLabTableData",
  async (param, { rejectWithValue }) => {
    try {
      const response = await LabService.fetchLabTableData(param);
      const code = response.code;
      return {
        code: code,
        datas: response.data,
      };
    } catch (err) {
      return rejectWithValue(
        { code: err.response.status, error: err.response?.data.errors } || {
          error: "Error creating a role",
        }
      );
    }
  }
);

export const labReceive = createAsyncThunk(
  "/labReceive",
  async (data, { rejectWithValue }) => {
    try {
      const response = await LabService.labReceive(data);
      const code = response.code;
      return {
        code: code,
        datas: response.data,
      };
    } catch (err) {
      return rejectWithValue(
        { code: err.response.status, error: err.response?.data.errors } || {
          error: "Error creating a role",
        }
      );
    }
  }
);

export const phlebotomyDrawHistoryForLab = createAsyncThunk(
  "/phlebotomyDrawHistoryForLab",
  async (id, { rejectWithValue }) => {
    try {
      const response = await LabService.drawHistory(id);
      const code = response.code;
      return {
        code: code,
        data: response.data,
      };
    } catch (err) {
      return rejectWithValue(
        { code: err.response.status, error: err.response?.data.errors } || {
          error: "Error creating a role",
        }
      );
    }
  }
);

export const labSlice = createSlice({
  name: "lab",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = !state.loading;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLabTableData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLabTableData.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.datas;
      })
      .addCase(fetchLabTableData.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(labReceive.pending, (state) => {
        state.drawHistoryForLabLoading = true;
      })
      .addCase(labReceive.fulfilled, (state, action) => {
        state.drawHistoryForLabLoading = false;
        state.drawHistoryForLab = removeRecordForLab(
          state.drawHistoryForLab,
          action.payload.datas
        );
      })
      .addCase(labReceive.rejected, (state, action) => {
        state.drawHistoryForLabLoading = false;
      })
      .addCase(phlebotomyDrawHistoryForLab.pending, (state) => {
        state.drawHistoryForLabLoading = true;
      })
      .addCase(phlebotomyDrawHistoryForLab.fulfilled, (state, action) => {
        state.drawHistoryForLabLoading = false;
        state.drawHistoryForLab = action.payload.data;
      })
      .addCase(phlebotomyDrawHistoryForLab.rejected, (state, action) => {
        state.drawHistoryForLabLoading = false;
      });
  },
});

export const { showLoading } = labSlice.actions;

export default labSlice.reducer;
